import { Button, Field, Input } from "@fluentui/react-components";
import { Add16Regular, Dismiss16Regular } from "@fluentui/react-icons";
import { LabelWithInfo } from "../../labelWithInfo/LabelWithInfo";
import { IPredefinedQuestionsFormProps } from "./editObjective.types";

export const PredefinedQuestionsForm = (
  props: IPredefinedQuestionsFormProps,
): JSX.Element => {
  return (
    <>
      {props.fieldErrors.questions && (
        <div
          role="alert"
          aria-live="assertive"
          className={props.dialogContentStyles.feedbackError}
        >
          {props.fieldErrors.questions}
        </div>
      )}
      <div className={props.editStyles.questionSectionWrapper}>
        <Field
          label={
            <LabelWithInfo
              label="Questions"
              info="These questions will be asked exactly as written during the interview. Add 1–3 questions."
              required
            />
          }
        />
        {props.sampleQuestions.map((sq, idx) => (
          <div key={idx} className={props.editStyles.sampleQuestionRow}>
            <Input
              value={sq.text}
              placeholder={`Question ${idx + 1}`}
              disabled={props.isLoading}
              onChange={(_, data) =>
                props.onUpdateQuestion(idx, { text: data.value })
              }
            />
            <Button
              icon={<Dismiss16Regular />}
              appearance="subtle"
              disabled={props.isLoading}
              onClick={() => props.onRemoveQuestion(idx)}
              aria-label={`Remove question ${idx + 1}`}
            />
          </div>
        ))}
        <Button
          icon={<Add16Regular />}
          appearance="secondary"
          onClick={props.onAddQuestion}
          disabled={
            props.isLoading ||
            props.sampleQuestions.length >= props.maxQuestionsCount
          }
          className={props.editStyles.addAnswerButton}
        >
          Add question
        </Button>
      </div>
    </>
  );
};
